import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";

import type { Activity } from "Api/activity/types";
import { rescheduleActivityRequest } from "Api/activity/rescheduleActivity.request";

export const rescheduleActivity = createAsyncThunk<
  Activity,
  {
    activity: Activity;
    scheduled_at: string;
    organizationId: string;
    projectId: string;
  },
  AsyncThunkOptionType
>(
  "app/environment/actions/reschedule",
  async ({ activity, scheduled_at }, { rejectWithValue }) => {
    try {
      const reschedule = await rescheduleActivityRequest({
        activity,
        scheduled_at
      });

      return reschedule._embedded.entity;
    } catch (error: unknown) {
      const { code, status } = (error ?? {}) as {
        code?: number;
        status?: number;
      };
      if (![404, 403].includes(code ?? status ?? 0)) {
        logger(error, {
          action: "reschedule",
          meta: {
            activityId: activity.id
          }
        });
      }

      return rejectWithValue(error);
    }
  }
);
